import React from 'react';
import { Close as MuiClose } from '@mui/icons-material';

const Close = () => {
  return <MuiClose />;
};

export default Close;
